
export const assignCharPoint = (charp) => {
  console.log(charp)
  if ( charp  > 1114109)
    return;
  let max = 149;
  let x = 74;
  let min = 0;
  let c = 0;
  while (c++ < 20) {
    if (charp > UNICODE[x][0] ) {
      if (charp < UNICODE[x][1]) {
        return UNICODE[x][2];
      } else {
        min = x;
        let avg = (max + min) / 2
        x = Math.round(avg);
      }
    } else {
      let avg = (min + max ) / 2
      max = x;
      x = Math.round(avg);
    }
  }
  console.log('could not place char point', charp)
}

const UNICODE  = [[0,127,'basic latin'],
[128,255,'c1 controls and latin-1 supplement'],
[256,383,'latin extended-a'],
[384,591,'latin extended-b'],
[592,687,'ipa extensions'],
[688,767,'spacing modifier letters'],
[768,879,'combining diacritical marks'],
[880,1023,'greek/coptic'],
[1024,1279,'cyrillic'],
[1280,1327,'cyrillic supplement'],
[1328,1423,'armenian'],
[1424,1535,'hebrew'],
[1536,1791,'arabic'],
[1792,1871,'syriac'],
[1872,1919,'undefined'],
[1920,1983,'thaana'],
[1984,2303,'undefined'],
[2304,2431,'devanagari'],
[2432,2559,'bengali/assamese'],
[2560,2687,'gurmukhi'],
[2688,2815,'gujarati'],
[2816,2943,'oriya'],
[2944,3071,'tamil'],
[3072,3199,'telugu'],
[3200,3327,'kannada'],
[3328,3583,'malayalam'],
[3456,3583,'sinhala'],
[3584,3711,'thai'],
[3712,3839,'lao'],
[3840,4095,'tibetan'],
[4096,4255,'myanmar'],
[4256,4351,'georgian'],
[4352,4607,'hangul jamo'],
[4608,4991,'ethiopic'],
[4992,5023,'undefined'],
[5024,5119,'cherokee'],
[5120,5759,'unified canadian aboriginal syllabics'],
[5760,5791,'ogham'],
[5792,5887,'runic'],
[5888,5919,'tagalog'],
[5920,5951,'hanunoo'],
[5952,5983,'buhid'],
[5984,6015,'tagbanwa'],
[6016,6143,'khmer'],
[6144,6319,'mongolian'],
[6320,6399,'undefined'],
[6400,6479,'limbu'],
[6480,6527,'tai le'],
[6528,6623,'undefined'],
[6624,6655,'khmer symbols'],
[6656,7423,'undefined'],
[7424,7551,'phonetic extensions'],
[7552,7679,'undefined'],
[7680,7935,'latin extended additional'],
[7936,8191,'greek extended'],
[8192,8303,'general punctuation'],
[8304,8351,'superscripts and subscripts'],
[8352,8399,'currency symbols'],
[8400,8447,'combining diacritical marks for symbols'],
[8448,8527,'letterlike symbols'],
[8528,8591,'number forms'],
[8592,8703,'arrows'],
[8704,8959,'mathematical operators'],
[8960,9215,'miscellaneous technical'],
[9216,9279,'control pictures'],
[9280,9311,'optical character recognition'],
[9312,9471,'enclosed alphanumerics'],
[9472,9599,'box drawing'],
[9600,9631,'block elements'],
[9632,9727,'geometric shapes'],
[9728,9983,'miscellaneous symbols'],
[9984,10175,'dingbats'],
[10176,10223,'miscellaneous mathematical symbols-a'],
[10224,10239,'supplemental arrows-a'],
[10240,10495,'braille patterns'],
[10496,10623,'supplemental arrows-b'],
[10624,10751,'miscellaneous mathematical symbols-b'],
[10752,11007,'supplemental mathematical operators'],
[11008,11263,'miscellaneous symbols and arrows'],
[11264,11903,'undefined'],
[11904,12031,'cjk radicals supplement'],
[12032,12255,'kangxi radicals'],
[12256,12015,'undefined'],
[12272,12287,'ideographic description characters'],
[12288,12351,'cjk symbols and punctuation'],
[12352,12447,'hiragana'],
[12448,12543,'katakana'],
[12544,12591,'bopomofo'],
[12592,12687,'hangul compatibility jamo'],
[12688,12703,'kanbun (kunten)'],
[12704,12735,'bopomofo extended'],
[12736,12783,'undefined'],
[12784,12799,'katakana phonetic extensions'],
[12800,13055,'enclosed cjk letters and months'],
[13056,13311,'cjk compatibility'],
[13312,19903,'cjk unified ideographs extension a'],
[19904,19967,'yijing hexagram symbols'],
[19968,40879,'cjk unified ideographs'],
[40880,40959,'undefined'],
[40960,42127,'yi syllables'],
[42128,42191,'yi radicals'],
[42192,44031,'undefined'],
[44032,55215,'hangul syllables'],
[55216,55295,'undefined'],
[55296,56319,'high surrogate area'],
[56320,57343,'low surrogate area'],
[57344,63743,'private use area'],
[63744,64255,'cjk compatibility ideographs'],
[64256,64335,'alphabetic presentation forms'],
[64336,65023,'arabic presentation forms-a'],
[65024,65039,'variation selectors'],
[65040,65055,'undefined'],
[65056,65071,'combining half marks'],
[65072,65103,'cjk compatibility forms'],
[65104,65135,'small form variants'],
[65136,65279,'arabic presentation forms-b'],
[65280,65519,'halfwidth and fullwidth forms'],
[65520,65535,'specials'],
[65536,65663,'linear b syllabary'],
[65664,65791,'linear b ideograms'],
[65792,65855,'aegean numbers'],
[65856,66303,'undefined'],
[66304,66351,'old italic'],
[66352,66383,'gothic'],
[66432,66463,'ugaritic'],
[66560,66639,'deseret'],
[66640,66687,'shavian'],
[66688,66735,'osmanya'],
[66736,67583,'undefined'],
[67584,67647,'cypriot syllabary'],
[67648,118783,'undefined'],
[118784,119039,'byzantine musical symbols'],
[119040,119295,'musical symbols'],
[119296,119551,'undefined'],
[119552,119647,'tai xuan jing symbols'],
[119648,119807,'undefined'],
[119808,120831,'mathematical alphanumeric symbols'],
[120832,131071,'undefined'],
[131072,173791,'cjk unified ideographs extension b'],
[173792,194559,'undefined'],
[194560,195103,'cjk compatibility ideographs supplement'],
[195248,917503,'unused'],
[917504,917631,'tags'],
[917632,917759,'unused'],
[917760,917999,'variation selectors supplement'],
[918000,983039,'unused'],
[983040,1048573,'supplementary private use area-a'],
[1048574,1048575,'unused'],
[1048576,1114109,'supplementary private use area-b']]

export default assignCharPoint;
